var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForceSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.8,
    r: 12,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 18.1333V16.8H8.49984L8.23317 16.5667C7.65539 16.0556 7.24984 15.4722 7.0165 14.8167C6.78317 14.1611 6.6665 13.5 6.6665 12.8333C6.6665 11.6 7.03595 10.5028 7.77484 9.54167C8.51373 8.58056 9.47762 7.94445 10.6665 7.63334V9.03334C9.8665 9.32223 9.22206 9.8139 8.73317 10.5083C8.24428 11.2028 7.99984 11.9778 7.99984 12.8333C7.99984 13.3333 8.09428 13.8195 8.28317 14.2917C8.47206 14.7639 8.7665 15.2 9.1665 15.6L9.33317 15.7667V14.1333H10.6665V18.1333H6.6665ZM13.3332 17.9667V16.5667C14.1332 16.2778 14.7776 15.7861 15.2665 15.0917C15.7554 14.3972 15.9998 13.6222 15.9998 12.7667C15.9998 12.2667 15.9054 11.7806 15.7165 11.3083C15.5276 10.8361 15.2332 10.4 14.8332 10L14.6665 9.83334V11.4667H13.3332V7.46667H17.3332V8.80001H15.4998L15.7665 9.03334C16.3109 9.57779 16.7082 10.1695 16.9582 10.8083C17.2082 11.4472 17.3332 12.1 17.3332 12.7667C17.3332 14 16.9637 15.0972 16.2248 16.0583C15.4859 17.0195 14.5221 17.6556 13.3332 17.9667Z",
    fill: "#5E6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForceSync);
export default __webpack_public_path__ + "static/media/ICON_FORCE_SYNC.4858f1bab5957ccc2e69585b307209c3.svg";
export { ForwardRef as ReactComponent };